import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, ActionSheetController, ModalController, LoadingController } from 'ionic-angular';
import { SpeakerData } from '../../providers/speaker';
import { AuthData } from '../../providers/auth';
import { Translate } from '../../providers/translate';
import { EventData } from '../../providers/event';
import { EventCommentPage } from '../event-comment/event-comment';
import { EventResourcePage } from '../event-resource/event-resource';
import { LoginPage } from '../login/login';

@Component({
  selector: 'page-event-speaker',
  templateUrl: 'event-speaker.html'
})
export class EventSpeakerPage {

  obs1: any;
  obs2: any;
  user: any;
  dataSpeaker: any;
  resourceSpeaker: any;
  event: any;
  client: any;
  likeBloqued: any = null;
  likes: any;
  comments: any = null;
  toastError: any;
  textTranslate: any;

  constructor(public navCtrl: NavController, params: NavParams, public speakerProvider: SpeakerData, public toastCtrl: ToastController, public auth: AuthData, public actionSheetCtrl: ActionSheetController, public modalCtrl: ModalController, public loadingCtrl: LoadingController, public eventProvider: EventData, translate: Translate) {
    translate.translateGroup(["Gracias por tu Like", 'Más opciones', 'Agregar a favoritos', 'Compartir', 'Cancelar', "Debe iniciar sesión antes de continuar", "Conferencista guardado en favoritos",'Comentarios Conferencista', 'Recursos']).then(result => {
      this.textTranslate = result;
    });
    this.event = params.get('event');
    this.client = params.get('client');

    this.obs1 = this.speakerProvider.getSpeaker(this.client, params.get('speaker').id).subscribe((data: any) => {
      this.dataSpeaker = data;

      this.speakerProvider.getMyLike(this.client, this.dataSpeaker.id)
      .then((result: any) => {
        if (result.val()) {
          this.likeBloqued = 1;
        } else {
          this.likeBloqued = -1;
        }
      });
    });
  }

  sendLike() {
    this.likeBloqued = null;
    this.speakerProvider.pushLike(this.client, this.dataSpeaker.id)
    .then(result => {
      this.likeBloqued = 1;

      // Increase counter dashboard
      this.eventProvider.setTransactionDashboard(this.client, this.event, 'numLikesSpeaker');

      let toast = this.toastCtrl.create({
        message: this.textTranslate["Gracias por tu Like"],
        duration: 2000,
        dismissOnPageChange: true
      });
      toast.present();
    })
  }

  moreOptions(speaker) {
    let actionSheet = this.actionSheetCtrl.create({
      title: this.textTranslate['Más opciones'],
      buttons: [
        {
          icon: 'heart',
          text: this.textTranslate['Agregar a favoritos'],
          handler: () => {
            this.favorite(speaker);
          }
        },
        {
          icon: 'md-share',
          text: this.textTranslate['Compartir'],
          handler: () => {
            console.log('Archive clicked');
          }
        },
        {
          icon: 'close',
          text: this.textTranslate['Cancelar'],
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    actionSheet.present();
  }

  favorite(speaker) {
    if (this.auth.getUser().isAnonymous) {
        let modal = this.modalCtrl.create(LoginPage, {client: this.client, event: this.event})
        modal.present();

        let toast = this.toastCtrl.create({
          message: this.textTranslate["Debe iniciar sesión antes de continuar"],
          duration: 5000,
          position: 'top'
        });
        toast.present();
    } else {
      let loading = this.loadingCtrl.create();
      loading.present();

      this.speakerProvider.pushFavorite(this.client, speaker)
      .then(() => {
        // Increase counter dashboard
        this.eventProvider.setTransactionDashboard(this.client, this.event, 'numFavorites');

        let toast = this.toastCtrl.create({
          message: this.textTranslate["Conferencista guardado en favoritos"],
          duration: 3000,
          dismissOnPageChange: true
        });
        loading.dismiss();
        toast.present();
      })
      .catch(error => {
        let toast = this.toastCtrl.create({
          message: error,
          duration: 3000,
          dismissOnPageChange: true
        });
        loading.dismiss();
        toast.present();
      });
    }
  }

  viewComments() {
    this.navCtrl.push(EventCommentPage, {type: 'speaker', event: this.event, token: this.dataSpeaker.id, title: this.textTranslate['Comentarios Conferencista'], client: this.client});
  }

  viewResources() {
    this.navCtrl.push(EventResourcePage, {title: this.textTranslate['Recursos'], speakerId: this.dataSpeaker.id, client: this.client, event: this.event});
  }

  // Unsubsucribe observables on exit page
  ionViewWillUnload() {
    console.log('Se eliminan los observable page-speaker', 'obs1');
    this.obs1.unsubscribe();
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pages/event-speaker/event-speaker.ts